import { useState } from 'react';

export default function DemoBookingModal({ open, onClose, booking }) {
  const [step, setStep]     = useState('form');
  const [form, setForm]     = useState({ nombre: '', email: '', telefono: '' });
  const [errors, setErrors] = useState({});

  function reset() {
    setStep('form');
    setForm({ nombre: '', email: '', telefono: '' });
    setErrors({});
  }

  function handleClose() { reset(); onClose(); }

  function handleSubmit(e) {
    e.preventDefault();
    const errs = {};
    if (!form.nombre.trim()) errs.nombre = 'Requerido';
    if (!form.email.trim() || !form.email.includes('@')) errs.email = 'Email inválido';
    if (Object.keys(errs).length) return setErrors(errs);
    setStep('success');
  }

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 24, backdropFilter: 'blur(4px)',
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: 'var(--surface)', borderRadius: 'var(--r-xl)',
          padding: 32, maxWidth: 400, width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
          border: '1px solid var(--border)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {step === 'form' ? (
          <>
            <div style={{ fontFamily: 'var(--font-head)', fontWeight: 800, fontSize: '1.2rem', color: 'var(--text-primary)', marginBottom: 4 }}>
              Reservar turno
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
              {booking}
            </div>
            <form onSubmit={handleSubmit}>
              <ModalField label="Nombre y apellido" error={errors.nombre}>
                <input
                  value={form.nombre}
                  onChange={e => { setForm(f => ({ ...f, nombre: e.target.value })); setErrors(er => ({ ...er, nombre: '' })); }}
                  style={inputStyle} placeholder="Juan García"
                />
              </ModalField>
              <ModalField label="Email" error={errors.email}>
                <input
                  type="email" value={form.email}
                  onChange={e => { setForm(f => ({ ...f, email: e.target.value })); setErrors(er => ({ ...er, email: '' })); }}
                  style={inputStyle} placeholder="juan@email.com"
                />
              </ModalField>
              <ModalField label="Teléfono (opcional)">
                <input
                  value={form.telefono}
                  onChange={e => setForm(f => ({ ...f, telefono: e.target.value }))}
                  style={inputStyle} placeholder="11 1234-5678"
                />
              </ModalField>
              <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                <button type="submit" style={{
                  flex: 1, padding: '11px 0', borderRadius: 'var(--r-full)',
                  background: 'var(--green)', color: '#fff', border: 'none',
                  fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: 14, cursor: 'pointer',
                }}>
                  Confirmar turno
                </button>
                <button type="button" onClick={handleClose} style={{
                  padding: '11px 18px', borderRadius: 'var(--r-full)',
                  background: 'transparent', border: '1px solid var(--border)',
                  color: 'var(--text-muted)', cursor: 'pointer', fontSize: 13,
                }}>
                  Cancelar
                </button>
              </div>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
            <div style={{ fontFamily: 'var(--font-head)', fontWeight: 800, fontSize: '1.2rem', color: 'var(--text-primary)', marginBottom: 8 }}>
              ¡Turno reservado!
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 12 }}>{booking}</div>
            <div style={{
              fontSize: 11, color: 'var(--text-muted)', marginBottom: 24,
              background: 'var(--bg3)', borderRadius: 'var(--r-md)',
              padding: '5px 14px', display: 'inline-block',
            }}>
              Modo demo · No se guardaron datos reales
            </div>
            <br />
            <button onClick={handleClose} style={{
              padding: '10px 28px', borderRadius: 'var(--r-full)',
              background: 'var(--green)', color: '#fff', border: 'none',
              fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: 14, cursor: 'pointer',
            }}>
              Volver
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: 'var(--r-md)',
  border: '1px solid var(--border)', background: 'var(--bg3)',
  color: 'var(--text-primary)', fontFamily: 'var(--font-body)', fontSize: 13,
  boxSizing: 'border-box',
};

function ModalField({ label, error, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', color: 'var(--text-muted)', marginBottom: 5 }}>
        {label.toUpperCase()}
      </div>
      {children}
      {error && <div style={{ fontSize: 11, color: '#ef4444', marginTop: 4 }}>{error}</div>}
    </div>
  );
}
